import * as propertyInfo from "./propertyInfoFn";
import navigationsLinks from "../../../constants/navigation_links";
import { updateStepToActive, thunkClearEstimateData } from "../../reducers/progress/progressReducer";
import { updateProgressSession } from "../../reducers/progress/progressFn";
import {
  // getClientTimezone,
  updateOrderData,
} from "../../../adapters/estimate/estimateAdapters";
import { verifyOrderInDB } from "../../../functions/helper";
//actions
export const UPDATE_PROPERTY_INFO = "propertyInfo/update";
export const CLEAR_MOVE_INFO = "propertyInfo/clear";
export const LOAD_PROPERTY_INFO = "propertyInfo/load";
export const LOAD_FROM_SESSION = "propertyInfo/loadFromLocalSession";
export const UPDATE_SUBMIT_STATUS = "propertyInfo/updateFormSubmitStatus";
export const CLEAR_FROM_ADDRESS_INFO = "propertyInfo/clear_from_address";
export const CLEAR_TO_ADDRESS_INFO = "propertyInfo/clear_to_address";
//reducers
export default function propertyInfoReducer(
  state = propertyInfo.getInitState(),
  action = {}
) {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_PROPERTY_INFO:
      return propertyInfo.updatePropertyInfo(state, payload);
    case UPDATE_SUBMIT_STATUS:
      return propertyInfo.updateFormSubmit(state, payload);
    case LOAD_FROM_SESSION:
      return propertyInfo.updateFromLocalSession(state, payload);
    case CLEAR_MOVE_INFO:
      return propertyInfo.getInitState();
    case CLEAR_FROM_ADDRESS_INFO:
      return propertyInfo.clearFromPropertyInfo(state, payload);
    case CLEAR_TO_ADDRESS_INFO:
      return propertyInfo.clearToPropertyInfo(state, payload);
    default:
      return state;
  }
}

//actions creators
export function loadPropertyInfoState(data) {
  return { type: LOAD_PROPERTY_INFO, payload: data };
}
export function updatePropertyInfoState(data) {
  return { type: UPDATE_PROPERTY_INFO, payload: data };
}
export function clearPropertyInfoState(data) {
  return { type: CLEAR_MOVE_INFO, payload: data };
}
export function updateFormSubmitStatus(data) {
  return { type: UPDATE_SUBMIT_STATUS, payload: data };
}
export function updateStateFromLocalSession(data) {
  return { type: LOAD_FROM_SESSION, payload: data };
}
export function resetFromAddressState(data) {
  return { type: CLEAR_FROM_ADDRESS_INFO, payload: data };
}
export function resetToAddressState(data) {
  return { type: CLEAR_TO_ADDRESS_INFO, payload: data };
}
const collectPropertyInfoData = async () => {

  const userSessionData = JSON.parse(sessionStorage.getItem("userSessionData"));
  const sessionOrderDetails = JSON.parse(
    sessionStorage.getItem("orderDetails")
  );
  const estimateId = sessionOrderDetails.orderId;
  // const moveInfo = JSON.parse(sessionStorage.getItem("move_info"));
  const propertyInfo = JSON.parse(sessionStorage.getItem("property_info"));
  const userId = userSessionData.userId;
  const customerName = userSessionData.customerName;
  // const clientTimezone = getClientTimezone();

  const fromAddress = {
    firstName: customerName,
    lastName: "",
    fromAddress: propertyInfo.old_house_address,
    fromLocality: propertyInfo.old_house_location,
    fromCity: propertyInfo.old_house_city,
    fromState: propertyInfo.old_house_state,
    pincode: propertyInfo.old_house_pincode,
  };

  const toAddress = {
    firstName: customerName,
    lastName: "",
    toAddress: propertyInfo.new_house_address,
    toLocality: propertyInfo.new_house_location,
    toCity: propertyInfo.new_house_city,
    toState: propertyInfo.new_house_state,
    pincode: propertyInfo.new_house_pincode,
  };

  const body = {
    old_floor_no: propertyInfo.old_house_floor_number,
    new_floor_no: propertyInfo.new_house_floor_number,
    old_elevator_availability: propertyInfo.old_house_elevator_available,
    packing_service: "Yes",
    new_elevator_availability: propertyInfo.new_house_elevator_available,
    unpacking_service: "No",
    old_parking_distance:
      Math.floor(propertyInfo.old_house_distance) + " meters",
    new_parking_distance:
      Math.floor(propertyInfo.new_house_distance) + " meters",
    old_house_additional_info: "",
    new_house_additional_info: "",
    from_address: JSON.stringify(fromAddress),
    to_address: JSON.stringify(toAddress),
    lead_stage: "floor_selected",
    version: "v2",
    estimate_id: estimateId,
    user_id: userId,
    update_type: "property_info",
  };

  const params = body;
  try {
    const response = await updateOrderData(params);
    console.log(response);
    // if (
    //   response.data.meta.code === 200 &&
    //   response.data.meta.status === "OK"
    // ) {
    //   console.log(response);
    //   // const estimateId = response.data.data.estimate_id;
    //   // const orderDetails = { orderId: estimateId, dateCreated: new Date() };
    //   // sessionStorage.setItem("orderDetails", JSON.stringify(orderDetails));
    //   // dispatch(thunkClearEstimateData({ history }));
    //   // history.push(navigationsLinks.confirmation_page + "/" + estimateId);
    //   // setSubmitProgress(false);
    //   return { status: true };
    // }
  } catch (e) {
    console.error(e);
    // setSubmitProgress(false);
    // setError({
    //   status: true,
    //   message: "OOP's! An Error Occurred, Please try again later.",
    // });
  }
};
//action creators which returns functions
export function thunkSubmitPropertyInfoForm(payload) {
  return async (dispatch, getState) => {
    dispatch(updateFormSubmitStatus({ status: true }));
    const { data, history } = payload;

    const isOrderOutdated = await verifyOrderInDB("relocation");
    if (isOrderOutdated === true) {
      dispatch(thunkClearEstimateData());
      history.push("/");
      return;
    }
    try {
      const propertyInfoData = propertyInfo.prepareRequestData(data);
      // const result = await saveDataToSession({
      //   form_data: propertyInfoData,
      //   type: "property_info",
      //   request_type: "update",
      // // });
      // console.log(propertyInfoData);
      sessionStorage.setItem("property_info", JSON.stringify(propertyInfoData));
      dispatch(updateFormSubmitStatus({ status: false }));
      dispatch(updatePropertyInfoState(data));
      dispatch(updateStepToActive({ stepToUpdate: "step2" }));
      updateProgressSession("step2");
      await collectPropertyInfoData();
      if (payload.gotoPage !== undefined) {
        history.push(payload.gotoPage);
      } else {
        history.push(navigationsLinks.inventory_page);
      }
    } catch (e) {
      dispatch(updateFormSubmitStatus({ status: false }));

      console.error("Error", e);
    }
    // dispatch(updateMoveInfoState(data));
  };
}
export function thunkLoadPropertyInfoFromSession(payload) {
  return (dispath, state) => {
    const propertyInfoData = JSON.parse(payload.propertyInfo);
    dispath(updateStateFromLocalSession(propertyInfoData));
  };
}
